import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var CalendlyController = /*#__PURE__*/function () {
  function CalendlyController() {
    _classCallCheck(this, CalendlyController);
  }
  _createClass(CalendlyController, null, [{
    key: "getUrl",
    value:
    // to use this class, make sure Calendly script is loaded

    function getUrl(link) {
      return "https://calendly.com/".concat(link);
    }
  }, {
    key: "showPopup",
    value: function showPopup(url) {
      Calendly.showPopupWidget(url);
    }
  }]);
  return CalendlyController;
}();
export { CalendlyController as default };